import React from "react";
import { FormattedMessage } from "react-intl";

import {
  CallText,
  LabelsContainer,
  PrimaryText,
  SecondaryText,
} from "./styles";

export default function Labels({
  primaryText,
  secondaryText,
  callText,
  size,
  callBackground,
  textColor,
  callTextColor,
  top = 0,
  left = 0,
}) {
  return (
    <LabelsContainer size={size} top={top} left={left}>
      <SecondaryText size={size} color={textColor}>
        {secondaryText ?? (
          <FormattedMessage id={"ai_creator.layout.secondaryText"} />
        )}
      </SecondaryText>
      <PrimaryText size={size} color={textColor}>
        {primaryText ?? (
          <FormattedMessage id={"ai_creator.layout.primaryText"} />
        )}
      </PrimaryText>
      <CallText size={size} color={callTextColor} background={callBackground}>
        {callText ?? <FormattedMessage id={"ai_creator.layout.callText"} />}
      </CallText>
    </LabelsContainer>
  );
}

export function DraggableLabels({
  size,
  textColor,
  secondaryText,
  primaryText,
  callText,
  callBackground,
  callTextColor,
}) {
  return (
    <>
      <SecondaryText size={size} color={textColor}>
        {secondaryText}
      </SecondaryText>
      <PrimaryText size={size} color={textColor}>
        {primaryText}
      </PrimaryText>
      <CallText size={size} color={callTextColor} background={callBackground}>
        {callText}
      </CallText>
    </>
  );
}
